import { render, staticRenderFns } from "./BlogDetailsContent.vue?vue&type=template&id=1153b49a&"
import script from "./BlogDetailsContent.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports